import React, { useEffect, useState } from 'react';
import styles from '../bygabivianna/bygabivianna.module.scss';
import perfil from '../bygabivianna/src/perfil.png';
import bloomclub from '../bygabivianna/src/bloomclub.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'bygabivianna@gmail.com';
const WHATSAPP_NUMBER = '5521967390505';
const INSTAGRAM_URL =
    'https://www.instagram.com/bygabivianna?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==';
const TIKTOK_URL = 'https://www.tiktok.com/@bygabivianna';
const BLOOM_CLUB_URL =
    'https://chat.whatsapp.com/Jo7mhIsNk4yKaQnnyVc4aR?s=sw&p=i&mlu=0&ilr=0';
const SHOPEE_URL = 'https://br.shp.ee/5yzu04d6?fromSource=copy_link&smtt=0.0.9';
const SHEIN_URL = 'https://onelink.shein.com/50/60jb8wmx1mbi';
const ICON_COLOR = '#ce7273';

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    email: string;
    whatsapp: string;
    modal: 'contact';
};

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom: string;
    site: string;
    modal: true;
};

type BloomCard = {
    id: number;
    image: string;
    brand: string;
    link: string;
    modal: 'bloom';
};

type SheinCard = {
    id: number;
    image: string;
    brand: string;
    searchCode: string;
    link: string;
    modal: 'shein';
};

type LinkCard = {
    id: number;
    image: string;
    brand: string;
    link: string;
    modal?: false;
};

type ModalCard = ContactCard | CupomCard | BloomCard | SheinCard;
type CardItem = ContactCard | CupomCard | BloomCard | SheinCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Contatos',
        email: EMAIL,
        whatsapp: WHATSAPP_NUMBER,
        modal: 'contact',
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        brand: 'Bloom Club',
        link: BLOOM_CLUB_URL,
        modal: 'bloom',
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'TikTok Shop',
        link: 'https://vt.tiktok.com/ZS9BXdA2S2Wqj-YOiim/',
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        brand: 'Aura Beauty',
        cupom: 'BYGABI',
        site: 'https://aurabeautyclub.com.br/?utm_source=creatorsclub&utm_campaign=afiliadas&utm_content=BYGABI%7C%7Cnemu_gYWIwamhqc6qD1',
        modal: true,
    },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        brand: 'Vitrine Riachuelo',
        link: 'https://www.riachuelo.com.br/?utm_source=awin&utm_id=3019247_&utm_campaign=affiliate&sv1=affiliate&sv_campaign_id=3019247&awc=86589_1788115654_e80b45ef2a9b3c80f95177662d92d808',
    },
    {
        id: 6,
        image: require('./src/cards/6.png'),
        brand: 'Minha C&A',
        link: 'https://www.cea.com.br/?utm_source=mais&utm_medium=minhacea&utm_campaign=bygabivianna',
    },
    {
        id: 7,
        image: require('./src/cards/7.png'),
        brand: 'Vitrine Shopee',
        link: SHOPEE_URL,
    },
    {
        id: 8,
        image: require('./src/cards/8.png'),
        brand: 'Vitrine SHEIN',
        searchCode: '2N452',
        link: SHEIN_URL,
        modal: 'shein',
    },
];

const Bygabivianna: React.FC = () => {
    const [activeCard, setActiveCard] = useState<ModalCard | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    const handleCopy = async () => {
        if (!activeCard) return;
        const text =
            activeCard.modal === true
                ? activeCard.cupom
                : activeCard.modal === 'shein'
                  ? activeCard.searchCode
                  : null;
        if (!text) return;
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.bygabivianna}>
            <div className={styles.container}>
                <img src={perfil} alt="Gabi Vianna" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="WhatsApp"
                    >
                        <WhatsappIcon height="28" color={ICON_COLOR} />
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="24" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => {
                                    setCopied(false);
                                    setActiveCard(card);
                                }}
                                aria-label={`Abrir ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={card.brand} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {activeCard ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="bygabivianna-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        {activeCard.modal === 'contact' ? (
                            <>
                                <p className={styles.modalEyebrow}>Parcerias</p>
                                <h2 id="bygabivianna-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>
                                <div className={styles.contactActions}>
                                    <a
                                        href={`mailto:${activeCard.email}`}
                                        className={styles.contactBtnEmail}
                                    >
                                        <svg
                                            height="22"
                                            width="22"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                            />
                                        </svg>
                                        <span>E-mail</span>
                                    </a>
                                    <a
                                        href={`https://wa.me/${activeCard.whatsapp}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.contactBtnWhatsapp}
                                    >
                                        <WhatsappIcon height="22" color="currentColor" />
                                        <span>WhatsApp</span>
                                    </a>
                                </div>
                            </>
                        ) : activeCard.modal === 'bloom' ? (
                            <div className={styles.bloomClub}>
                                <img
                                    src={bloomclub}
                                    alt="Bloom Club by Gabi"
                                    className={styles.bloomLogo}
                                />
                                <p className={styles.bloomText}>
                                    Ofertas, novidades e um cantinho só nosso no WhatsApp.
                                </p>
                                <a
                                    href={activeCard.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.bloomBtn}
                                >
                                    Entrar no grupo VIP
                                </a>
                            </div>
                        ) : activeCard.modal === 'shein' ? (
                            <div className={styles.sheinClub}>
                                <p className={styles.modalEyebrow}>Escolhas exclusivas</p>
                                <h2 id="bygabivianna-modal-title" className={styles.modalBrand}>
                                    SHEIN
                                </h2>
                                <p className={styles.sheinText}>
                                    Descubra minhas escolhas da SHEIN, selecionadas especialmente
                                    para você. Digite o código na barra de busca para ver meus
                                    favoritos.
                                </p>
                                <div className={styles.cupomBox}>
                                    <span className={styles.cupomLabel}>Código de busca</span>
                                    <span className={styles.cupomCode}>{activeCard.searchCode}</span>
                                    <button
                                        type="button"
                                        className={styles.copyBtn}
                                        onClick={handleCopy}
                                    >
                                        {copied ? 'Copiado' : 'Copiar código'}
                                    </button>
                                </div>
                                <p className={styles.sheinPerk}>
                                    50% OFF para todo novo usuário. Garanta já o seu.
                                </p>
                                <a
                                    href={activeCard.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.siteBtn}
                                >
                                    Ir para a SHEIN
                                </a>
                            </div>
                        ) : (
                            <>
                                <p className={styles.modalEyebrow}>Cupom exclusivo</p>
                                <h2 id="bygabivianna-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>
                                <div className={styles.cupomBox}>
                                    <span className={styles.cupomLabel}>Seu cupom</span>
                                    <span className={styles.cupomCode}>{activeCard.cupom}</span>
                                    <button
                                        type="button"
                                        className={styles.copyBtn}
                                        onClick={handleCopy}
                                    >
                                        {copied ? 'Copiado' : 'Copiar cupom'}
                                    </button>
                                </div>
                                <a
                                    href={activeCard.site}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.siteBtn}
                                >
                                    Ir para o site
                                </a>
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Bygabivianna;
